import React, { createContext, useContext } from 'react';

import { type AbTest, type OverrideAbTestProps } from './types';

const Context = createContext<AbTest | undefined | null>(null);

export const OverrideAbTest = ({ children, abTest }: OverrideAbTestProps) => {
	return <Context.Provider value={abTest}>{children}</Context.Provider>;
};

export const useOverrideAbTest = () => {
	return useContext(Context);
};
